/**
 * GOAFREET RESOURCE & TOOL CATALOG
 * Curated directory of verified production tools, calculators, platform feeds, and research guides.
 * Every entry points to an active, working page.
 */

export const resourceCategories = [
  {
    slug: 'ecommerce-seller-tools',
    title: 'Quick Commerce & Marketplaces',
    description: 'Calculators and profit planners for Zepto, Blinkit, Swiggy Instamart, Amazon, Flipkart & Meesho.',
    icon: '🛒',
    theme: '#db2777',
    targetPath: '/tools/marketplace/',
  },
  {
    slug: 'seo-tools',
    title: 'SEO & Search Architecture',
    description: 'Structured data generators, robots validators, and SERP preview tools.',
    icon: '🔎',
    theme: '#0f766e',
    targetPath: '/tools/seo/schema-generator/',
  },
  {
    slug: 'image-optimization-tools',
    title: 'Image & Media Engine',
    description: 'In-browser image compressors, WebP/PNG converters, and AI upscalers.',
    icon: '⚡',
    theme: '#8b5cf6',
    targetPath: '/tools/image-optimization/image-compressor/',
  },
  {
    slug: 'developer-text-tools',
    title: 'Developer & Code Utilities',
    description: 'Diff checkers, JSON formatters, UUID generators, and code beautifiers.',
    icon: '💻',
    theme: '#2563eb',
    targetPath: '/tools/text/diff-checker/',
  },
  {
    slug: 'design-color-tools',
    title: 'Design & Visual Systems',
    description: 'Palette visualizers, WCAG contrast checkers, and Tailwind color tools.',
    icon: '🎨',
    theme: '#ea580c',
    targetPath: '/tools/palette-visualizer/',
  },
  {
    slug: 'platform-intelligence',
    title: 'Platform Intelligence & Policies',
    description: 'Official algorithm trackers and fee change feeds for Amazon, Flipkart, Google, and Meta.',
    icon: '📡',
    theme: '#0891b2',
    targetPath: '/resources/platform-updates/',
  },
  {
    slug: 'knowledge-base',
    title: 'Strategy Guides & Research',
    description: 'Web design architecture research, benchmarks, and case studies.',
    icon: '📚',
    theme: '#059669',
    targetPath: '/facts-about-website-designing/',
  },
  {
    slug: 'global-innovation-explorer',
    title: 'Global Innovation Explorer',
    description: 'Search verified global technologies, open-source repositories, algorithms, patents, and scientific research.',
    icon: '🌐',
    theme: '#10b981',
    targetPath: '/innovation/',
  },
  {
    slug: 'technology-news',
    title: 'Technology News',
    description: 'Verified official engineering announcements and release updates from leading technology creators worldwide.',
    icon: '📰',
    theme: '#2563eb',
    targetPath: '/technology-news/',
  },
  {
    slug: 'freemium-space',
    title: 'Free PDF Books & E-Books',
    description: 'Interactive 3D flipbook library of actionable design books, UX frameworks, and growth marketing guides.',
    icon: '📚',
    theme: '#1565c0',
    targetPath: '/freemium-space/',
  },
];

export const marketplaceHubs = [
  {
    slug: 'zepto',
    title: 'Zepto Seller Hub',
    description: 'Zepto quick commerce commission calculator, dark store margins, and fulfillment costs.',
    icon: '⚡',
    category: 'Quick Commerce',
    marketplace: 'Zepto',
    featured: true,
    popular: true,
    path: '/tools/quick-commerce/zepto-fee-calculator/',
  },
  {
    slug: 'blinkit',
    title: 'Blinkit Seller Hub',
    description: 'Blinkit seller margin calculator, dark store micro-hub fees, and net settlement payouts.',
    icon: '🟡',
    category: 'Quick Commerce',
    marketplace: 'Blinkit',
    featured: true,
    popular: true,
    path: '/tools/quick-commerce/blinkit-fee-calculator/',
  },
  {
    slug: 'swiggy-instamart',
    title: 'Swiggy Instamart Hub',
    description: 'Swiggy Instamart delivery economics, slab commissions, and fast-commerce margins.',
    icon: '🛵',
    category: 'Quick Commerce',
    marketplace: 'Swiggy Instamart',
    featured: true,
    popular: true,
    path: '/tools/quick-commerce/swiggy-instamart-fee-calculator/',
  },
  {
    slug: 'amazon',
    title: 'Amazon India Hub',
    description: 'Amazon India seller fee calculator, referral fee slabs, FBA fulfillment, and storage fees.',
    icon: '📦',
    category: 'Marketplace Tools',
    marketplace: 'Amazon India',
    featured: true,
    popular: true,
    path: '/tools/marketplace/amazon-fee-calculator/',
  },
  {
    slug: 'flipkart',
    title: 'Flipkart Seller Hub',
    description: 'Flipkart commission rates, closing fees, logistics shipping charges, and net margins.',
    icon: '🛍️',
    category: 'Marketplace Tools',
    marketplace: 'Flipkart',
    featured: true,
    popular: true,
    path: '/tools/marketplace/flipkart-commission-calculator/',
  },
  {
    slug: 'meesho',
    title: 'Meesho Seller Hub',
    description: 'Meesho zero-commission profit planner, return fraud estimator, and RTO loss analyzer.',
    icon: '🏷️',
    category: 'Marketplace Tools',
    marketplace: 'Meesho',
    featured: true,
    popular: true,
    path: '/tools/marketplace/in/meesho-profit-calculator/',
  },
  {
    slug: 'myntra',
    title: 'Myntra Fashion Hub',
    description: 'Myntra fashion commission structure, customer return buffers, and logistics costs.',
    icon: '👗',
    category: 'Marketplace Tools',
    marketplace: 'Myntra',
    featured: false,
    popular: true,
    path: '/tools/marketplace/in/myntra-commission-calculator/',
  },
  {
    slug: 'nykaa',
    title: 'Nykaa Beauty Hub',
    description: 'Nykaa cosmetics and wellness commission breakdown and retailer profitability calculator.',
    icon: '💄',
    category: 'Marketplace Tools',
    marketplace: 'Nykaa',
    featured: false,
    popular: false,
    path: '/tools/marketplace/in/nykaa-commission-calculator/',
  },
  {
    slug: 'ajio',
    title: 'AJIO Marketplace Hub',
    description: 'AJIO Reliance Retail commission tiers, closing charges, and return allowance analysis.',
    icon: '👕',
    category: 'Marketplace Tools',
    marketplace: 'AJIO',
    featured: false,
    popular: false,
    path: '/tools/marketplace/in/ajio-commission-calculator/',
  },
  {
    slug: 'amazon-usa',
    title: 'Amazon USA Hub',
    description: 'Amazon USA international selling, FBA tier fulfillment, and dollar profitability.',
    icon: '🇺🇸',
    category: 'Global Marketplace',
    marketplace: 'Amazon USA',
    featured: false,
    popular: false,
    path: '/tools/usa/amazon-fba-profit-calculator-usa/',
  },
  {
    slug: 'walmart',
    title: 'Walmart Marketplace Hub',
    description: 'Walmart US marketplace referral fees, WFS fulfillment, and seller economics.',
    icon: '🏪',
    category: 'Global Marketplace',
    marketplace: 'Walmart',
    featured: false,
    popular: false,
    path: '/tools/usa/walmart-marketplace-profit-calculator/',
  },
];

export const resourceTools = [
  // --- SEO & TECHNICAL SEARCH ---
  {
    slug: 'schema-generator',
    title: 'Smart Schema Generator',
    category: 'SEO Tools',
    description: 'Build valid JSON-LD structured data with guided validation, score checker, and instant copy.',
    icon: '🧩',
    featured: true,
    popular: true,
    badge: 'Popular',
    path: '/tools/seo/schema-generator/',
  },
  {
    slug: 'meta-tag-generator',
    title: 'Meta Tag Generator',
    category: 'SEO Tools',
    description: 'Create high-converting title tags, meta descriptions, OpenGraph, and Twitter Cards.',
    icon: '🏷️',
    featured: true,
    popular: true,
    badge: 'Essential',
    path: '/tools/seo/meta-tag-generator/',
  },
  {
    slug: 'robots-txt-validator',
    title: 'Robots.txt Validator',
    category: 'SEO Tools',
    description: 'Test crawl permissions, user-agent directives, and disallow syntax in real time.',
    icon: '🤖',
    featured: false,
    popular: true,
    badge: 'Technical',
    path: '/tools/seo/robots-txt-validator/',
  },
  {
    slug: 'sitemap-visualizer',
    title: 'Sitemap Visualizer',
    category: 'SEO Tools',
    description: 'Inspect XML sitemaps, analyze URL indexability, and detect indexing issues.',
    icon: '🗺️',
    featured: false,
    popular: false,
    badge: 'Diagnostic',
    path: '/tools/seo/sitemap-visualizer/',
  },
  {
    slug: 'serp-snippet-preview',
    title: 'SERP Snippet Preview',
    category: 'SEO Tools',
    description: 'Simulate Google desktop and mobile search snippet appearance with pixel-width limits.',
    icon: '📱',
    featured: false,
    popular: false,
    badge: 'Preview',
    path: '/tools/seo/serp-snippet-preview/',
  },

  // --- QUICK COMMERCE & INDIAN MARKETPLACES ---
  {
    slug: 'zepto-fee-calculator',
    title: 'Zepto Fee Calculator',
    category: 'Ecommerce Seller Tools',
    description: 'Calculate Zepto dark store space margins, fulfillment fees, and net settlement per unit.',
    icon: '⚡',
    featured: true,
    popular: true,
    badge: 'Quick Commerce',
    path: '/tools/quick-commerce/zepto-fee-calculator/',
  },
  {
    slug: 'blinkit-fee-calculator',
    title: 'Blinkit Fee Calculator',
    category: 'Ecommerce Seller Tools',
    description: 'Calculate Blinkit quick delivery margins, commissions, and grocery economics.',
    icon: '🟡',
    featured: true,
    popular: true,
    badge: 'Quick Commerce',
    path: '/tools/quick-commerce/blinkit-fee-calculator/',
  },
  {
    slug: 'swiggy-instamart-fee-calculator',
    title: 'Swiggy Instamart Calculator',
    category: 'Ecommerce Seller Tools',
    description: 'Forecast Swiggy Instamart delivery costs, slab commissions, and net profit margins.',
    icon: '🛵',
    featured: true,
    popular: true,
    badge: 'Quick Commerce',
    path: '/tools/quick-commerce/swiggy-instamart-fee-calculator/',
  },
  {
    slug: 'amazon-fee-calculator',
    title: 'Amazon India Fee Calculator',
    category: 'Ecommerce Seller Tools',
    description: 'Pre-filled Amazon India category referral fees, closing fees, FBA, and weight tiers.',
    icon: '📦',
    featured: true,
    popular: true,
    badge: 'Marketplace',
    path: '/tools/marketplace/amazon-fee-calculator/',
  },
  {
    slug: 'amazon-tacos-calculator',
    title: 'Amazon TACoS Calculator',
    category: 'Ecommerce Seller Tools',
    description: 'Calculate Total Advertising Cost of Sales for Amazon India sellers.',
    icon: '📈',
    featured: false,
    popular: true,
    badge: 'Advertising',
    path: '/tools/amazon/tacos-calculator/',
  },
  {
    slug: 'flipkart-tacos-calculator',
    title: 'Flipkart TACoS Calculator',
    category: 'Ecommerce Seller Tools',
    description: 'Calculate Total Advertising Cost of Sales for Flipkart ads.',
    icon: '🎯',
    featured: false,
    popular: true,
    badge: 'Advertising',
    path: '/tools/flipkart/tacos-calculator/',
  },
  {
    slug: 'flipkart-commission-calculator',
    title: 'Flipkart Commission Calculator',
    category: 'Ecommerce Seller Tools',
    description: 'Category-wise commission rates, fixed fees, and shipping charges for Flipkart sellers.',
    icon: '🛒',
    featured: true,
    popular: true,
    badge: 'Marketplace',
    path: '/tools/marketplace/flipkart-commission-calculator/',
  },
  {
    slug: 'meesho-profit-calculator',
    title: 'Meesho Profit Calculator',
    category: 'Ecommerce Seller Tools',
    description: 'Calculate true take-home profit on Meesho after shipping, GST input credit, and packaging.',
    icon: '🏷️',
    featured: true,
    popular: true,
    badge: 'Zero Commission',
    path: '/tools/marketplace/in/meesho-profit-calculator/',
  },
  {
    slug: 'gst-profit-calculator',
    title: 'GST Profitability Calculator',
    category: 'Ecommerce Seller Tools',
    description: 'Compute GST liability, input tax credit (ITC), and true post-tax margins on sales in India.',
    icon: '🧾',
    featured: false,
    popular: true,
    badge: 'Tax / GST',
    path: '/tools/marketplace/in/gst-profit-calculator/',
  },
  {
    slug: 'marketplace-price-parity',
    title: 'Price Parity Calculator',
    category: 'Ecommerce Seller Tools',
    description: 'Balance pricing across Amazon, Flipkart, Blinkit, and Zepto to preserve net profit parity.',
    icon: '⚖️',
    featured: false,
    popular: true,
    badge: 'Multi-Channel',
    path: '/tools/marketplace/in/marketplace-price-parity-calculator/',
  },

  // --- IMAGE & MEDIA ENGINE ---
  {
    slug: 'image-compressor',
    title: 'Ultra Image Compressor',
    category: 'Image Tools',
    description: 'Compress images up to 90% in-browser with zero quality loss and bulk ZIP export.',
    icon: '🗜️',
    featured: true,
    popular: true,
    badge: '90% Savings',
    path: '/tools/image-optimization/image-compressor/',
  },
  {
    slug: 'ai-image-upscaler',
    title: 'AI Image Upscaler',
    category: 'Image Tools',
    description: 'Enhance and upscale low-resolution images 2x to 4x using neural super-resolution.',
    icon: '✨',
    featured: true,
    popular: true,
    badge: 'AI Super-Res',
    path: '/tools/image-optimization/upscale-image/',
  },
  {
    slug: 'convert-to-webp',
    title: 'Convert to WebP',
    category: 'Image Tools',
    description: 'Convert PNG, JPG, and GIF images to modern WebP format for faster page speed scores.',
    icon: '🖼️',
    featured: true,
    popular: true,
    badge: 'Speed / WebP',
    path: '/tools/image-conversion/convert-to-webp/',
  },
  {
    slug: 'convert-to-png',
    title: 'Convert to PNG',
    category: 'Image Tools',
    description: 'Batch convert images to crisp PNG with full transparency support.',
    icon: '🎨',
    featured: false,
    popular: false,
    badge: 'Lossless',
    path: '/tools/image-conversion/convert-to-png/',
  },
  {
    slug: 'convert-to-jpg',
    title: 'Convert to JPG',
    category: 'Image Tools',
    description: 'Convert WebP, PNG, and HEIC files to universally compatible JPG format.',
    icon: '📷',
    featured: false,
    popular: false,
    badge: 'Universal',
    path: '/tools/image-conversion/convert-to-jpg/',
  },
  {
    slug: 'resize-image',
    title: 'Resize Image',
    category: 'Image Tools',
    description: 'Adjust image dimensions, aspect ratios, and pixel dimensions client-side.',
    icon: '📐',
    featured: false,
    popular: false,
    badge: 'Dimensions',
    path: '/tools/image-editing/resize-image/',
  },

  // --- DEVELOPER & TEXT PROCESSING ---
  {
    slug: 'diff-checker',
    title: 'Text Diff Checker',
    category: 'Developer Tools',
    description: 'Compare two text blocks or code snippets side-by-side with visual diff highlighting.',
    icon: '↔️',
    featured: true,
    popular: true,
    badge: 'Compare',
    path: '/tools/text/diff-checker/',
  },
  {
    slug: 'json-formatter',
    title: 'JSON Formatter & Validator',
    category: 'Developer Tools',
    description: 'Format, validate, prettify, and repair JSON strings with syntax tree navigation.',
    icon: '{ }',
    featured: true,
    popular: true,
    badge: 'Validation',
    path: '/tools/text/json-formatter/',
  },
  {
    slug: 'uuid-generator',
    title: 'UUID / GUID Generator',
    category: 'Developer Tools',
    description: 'Generate bulk cryptographically secure v4 UUIDs for databases and APIs.',
    icon: '🔑',
    featured: false,
    popular: false,
    badge: 'Security',
    path: '/tools/text/uuid-generator/',
  },
  {
    slug: 'regex-tester',
    title: 'Regex Tester',
    category: 'Developer Tools',
    description: 'Test regular expressions in real-time with match groups and explanation breakdown.',
    icon: '.*',
    featured: false,
    popular: false,
    badge: 'Utility',
    path: '/tools/text/regex-tester/',
  },
  {
    slug: 'code-beautifier',
    title: 'Code Beautifier',
    category: 'Developer Tools',
    description: 'Clean, format, and indent HTML, CSS, and JavaScript code instantly.',
    icon: '🪄',
    featured: false,
    popular: false,
    badge: 'Formatter',
    path: '/tools/text/code-beautifier/',
  },

  // --- DESIGN & COLOR SYSTEMS ---
  {
    slug: 'color-palette-hub',
    title: 'Color Palette Studio (Kolor Hub)',
    category: 'Design Tools',
    description: 'Central creative studio hub for harmonic palettes, contrast inspection, and brand design systems.',
    icon: '🎨',
    featured: true,
    popular: true,
    badge: 'Flagship Hub',
    path: '/tools/color-palette/',
  },
  {
    slug: 'color-scheme-tools',
    title: 'Explore Color Schemes',
    category: 'Design Tools',
    description: 'Browse thousands of curated harmonic color palettes and schemes by topic, mood, and style.',
    icon: '🎨',
    featured: true,
    popular: true,
    badge: '5,000+ Schemes',
    path: '/tools/design/color-scheme-tools/',
  },
  {
    slug: 'color-palette-generator',
    title: 'Color Palette Generator',
    category: 'Design Tools',
    description: 'Rapid spacebar-driven multi-shade generator with color locks, hex tweaking, and code export.',
    icon: '✨',
    featured: true,
    popular: true,
    badge: 'Generator',
    path: '/tools/design/color-palette-generator/',
  },
  {
    slug: 'palette-visualizer',
    title: 'Color Palette Visualizer',
    category: 'Design Tools',
    description: 'Test color palettes on simulated modern UI components before writing production CSS.',
    icon: '👁️',
    featured: true,
    popular: true,
    badge: 'UI Preview',
    path: '/tools/palette-visualizer/',
  },
  {
    slug: 'contrast-checker',
    title: 'WCAG Contrast Checker',
    category: 'Design Tools',
    description: 'Verify accessibility compliance (AA/AAA) between text and background colors.',
    icon: '🛡️',
    featured: false,
    popular: true,
    badge: 'Accessibility',
    path: '/tools/contrast-checker/',
  },
  {
    slug: 'color-wheel',
    title: 'Pantone Color Wheel',
    category: 'Design Tools',
    description: 'Interactive water ripple Pantone color wheel with 1-tap hex extraction.',
    icon: '🌊',
    featured: true,
    popular: true,
    badge: 'Pantone',
    path: '/tools/design/color-wheel/',
  },
  {
    slug: 'color-picker',
    title: 'Color Picker & Converter',
    category: 'Design Tools',
    description: 'Extract HEX, RGB, HSL, CMYK with live tonal scales, tints, and shades.',
    icon: '🖌️',
    featured: false,
    popular: true,
    badge: 'Values',
    path: '/tools/color-picker/',
  },
  {
    slug: 'image-picker',
    title: 'Image Palette Extractor',
    category: 'Design Tools',
    description: 'Extract authentic dominant color palettes directly from any photo or image.',
    icon: '🖼️',
    featured: false,
    popular: true,
    badge: 'Extractor',
    path: '/tools/image-picker/',
  },
  {
    slug: 'analogous-palette',
    title: 'Analogous Color Palette',
    category: 'Design Tools',
    description: 'Craft serene neighboring color schemes for natural visual flow (3 Colors).',
    icon: '🎨',
    featured: false,
    popular: false,
    badge: 'Harmony',
    path: '/tools/design/analogous-color-palette/',
  },
  {
    slug: 'complementary-palette',
    title: 'Complementary Color Palette',
    category: 'Design Tools',
    description: 'High-impact opposite color pairings for vibrant call-to-action accents.',
    icon: '🎨',
    featured: false,
    popular: false,
    badge: 'Harmony',
    path: '/tools/design/complementary-color-palette/',
  },
  {
    slug: 'monochromatic-palette',
    title: 'Monochromatic Color Palette',
    category: 'Design Tools',
    description: 'Sophisticated single-hue tonal gradients for minimal enterprise design.',
    icon: '🎨',
    featured: false,
    popular: false,
    badge: 'Harmony',
    path: '/tools/design/monochromatic-color-palette/',
  },
  {
    slug: 'triadic-palette',
    title: 'Triadic Color Palette',
    category: 'Design Tools',
    description: 'Balanced equilateral 120° geometric color harmony for rich visual energy.',
    icon: '🎨',
    featured: false,
    popular: false,
    badge: 'Harmony',
    path: '/tools/design/triadic-color-palette/',
  },
  {
    slug: 'split-complementary-palette',
    title: 'Split-Complementary Palette',
    category: 'Design Tools',
    description: 'Nuanced contrast with softer visual tension using adjacent complementary hues.',
    icon: '🎨',
    featured: false,
    popular: false,
    badge: 'Harmony',
    path: '/tools/design/split-complementary-color-palette/',
  },
  {
    slug: 'tetradic-palette',
    title: 'Tetradic Color Palette',
    category: 'Design Tools',
    description: 'Rich double complementary rectangular color harmony (4 Colors).',
    icon: '🎨',
    featured: false,
    popular: false,
    badge: 'Harmony',
    path: '/tools/design/tetradic-color-palette/',
  },
  {
    slug: 'square-palette',
    title: 'Square Color Palette',
    category: 'Design Tools',
    description: '90° geometric color wheel harmony for dashboards and data visualization.',
    icon: '🎨',
    featured: false,
    popular: false,
    badge: 'Harmony',
    path: '/tools/design/square-color-palette/',
  },
  {
    slug: '3d-exhibition-stand',
    title: '3D Exhibition Stand Visualizer',
    category: 'Design Tools',
    description: 'Interactive 4m × 3m Cosmoprof exhibition stall configurator with custom fabric & counter graphics.',
    icon: '🎪',
    featured: true,
    popular: true,
    badge: '3D Booth',
    path: '/tools/design/3d-exhibition-stand/',
  },
  {
    slug: 'design-distance-visualizer',
    title: '3D Design Distance Visualizer',
    category: 'Design Tools',
    description: 'Simulate viewing distances and human optical acuity for billboards, banners & exhibition prints.',
    icon: '👁️',
    featured: true,
    popular: true,
    badge: '3D Optics',
    path: '/tools/design/design-distance-visualizer/',
  },
  {
    slug: 'packaging-studio',
    title: '3D Packaging Studio',
    category: 'Design Tools',
    description: 'Interactive 3D mockups and product packaging visualizer.',
    icon: '📦',
    featured: false,
    popular: false,
    badge: '3D Studio',
    path: '/tools/design/packaging-studio/',
  },
  {
    slug: 'font-viewer',
    title: 'Font Viewer',
    category: 'Design Tools',
    description: 'Browse, test, and preview 1,950+ Google Fonts live with custom text, waterfall scales, and instant CSS export.',
    icon: '🔤',
    featured: true,
    popular: true,
    badge: '1,950+ Fonts',
    path: '/resources/font-viewer/',
  },
  {
    slug: 'font-pairing',
    title: 'Font Pairing Studio',
    category: 'Design Tools',
    description: 'AI & typographic contrast pairing engine with real-world SaaS, editorial, and eCommerce UI mockups.',
    icon: '✨',
    featured: true,
    popular: true,
    badge: 'Smart Harmony',
    path: '/resources/font-pairing/',
  },
  {
    slug: 'trending-fonts',
    title: 'Trending Font Family Radar',
    category: 'Design Tools',
    description: 'Curated 2026 typography leaderboard tracking fastest-rising fonts for SaaS, luxury, brutalism, and coding.',
    icon: '🔥',
    featured: true,
    popular: true,
    badge: '2026 Radar',
    path: '/resources/trending-fonts/',
  },
];

export const strategicGuides = [
  {
    slug: 'platform-updates-hub',
    title: 'Official Platform Updates Feed',
    category: 'Strategy & Intelligence',
    description: 'Real-time intelligence tracking verified fee updates, policy changes, and algorithm shifts.',
    icon: '📡',
    badge: 'Verified Feed',
    path: '/resources/platform-updates/',
  },
  {
    slug: 'amazon-updates',
    title: 'Amazon India Policy Tracker',
    category: 'Strategy & Intelligence',
    description: 'Track commission tier changes, referral fee modifications, and FBA fulfillment updates.',
    icon: '📦',
    badge: 'Amazon Feed',
    path: '/resources/platform-updates/amazon/',
  },
  {
    slug: 'flipkart-updates',
    title: 'Flipkart Marketplace Tracker',
    category: 'Strategy & Intelligence',
    description: 'Monitor Flipkart policy revisions, F-Assured criteria, and Big Billion Days requirements.',
    icon: '🛍️',
    badge: 'Flipkart Feed',
    path: '/resources/platform-updates/flipkart/',
  },
  {
    slug: 'google-search-updates',
    title: 'Google Search Core Updates',
    category: 'Strategy & Intelligence',
    description: 'Verified tracker of Google Core Algorithm updates, Helpful Content shifts, and spam policies.',
    icon: '🔎',
    badge: 'Google Search',
    path: '/resources/platform-updates/google/',
  },
  {
    slug: 'facts-about-website-designing',
    title: 'Web Architecture & Design Facts',
    category: 'Strategy & Intelligence',
    description: 'Empirical research and performance benchmarks on website speed, typography, and conversion engineering.',
    icon: '🌐',
    badge: 'Engineering',
    path: '/facts-about-website-designing/',
  },
  {
    slug: 'research-and-case-studies',
    title: 'Research & Client Case Studies',
    category: 'Strategy & Intelligence',
    description: 'Measurable case studies documenting digital growth, conversion optimization, and brand transformation.',
    icon: '📊',
    badge: 'Under Review',
    disabled: true,
    path: '#',
  },
  {
    slug: 'social-media-strategy-guide',
    title: 'Social Media Strategy Playbook',
    category: 'Strategy & Intelligence',
    description: 'Tactical guide to organic audience acquisition, content cadences, and ROI-driven marketing.',
    icon: '📱',
    badge: 'Social Strategy',
    path: '/social-media-strategy-guide/',
  },
];

export const featuredResources = resourceTools.filter((tool) => tool.featured);
export const popularResources = resourceTools.filter((tool) => tool.popular);
export const recentlyUpdated = [...resourceTools].slice(0, 8);

export const allResources = [
  ...resourceTools,
  ...marketplaceHubs,
  ...strategicGuides,
];

export const guideTopics = [];

export const getResourceBySlug = (slug) => allResources.find((item) => item.slug === slug);

export const getResourcesByCategory = (categorySlug) => {
  const category = resourceCategories.find((item) => item.slug === categorySlug);
  if (!category) {
    return [];
  }
  return allResources.filter((item) => item.category === category.title);
};
